import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

const settingMenus = (): CloudPremisePluginMenu[] => {
    return [
        {
            name: "Setup Iris",
            key: "iris",
            route: "/iris/setup",
            privacy: "private",
        },
    ];
};

export default settingMenus;